/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ExportDealsPipelineReportV2MutationRequest,
  ExportDealsPipelineReportV2MutationResponse,
  ExportDealsPipelineReportV2400,
  ExportDealsPipelineReportV2500,
} from '../types/ExportDealsPipelineReportV2'

function getExportDealsPipelineReportV2Url() {
  const res = {
    method: 'POST',
    url: `/api/v1/reports/dashboard/deals-pipeline/export/v2/` as const,
  }
  return res
}

/**
 * @description Start an async deals pipeline export.
 * Request body:
 * {
 * "selected_columns": ["company_name", "taro", "sales_stages"],
 * "export_type": "csv",
 * "filter_params": { ... },
 * "sort": "-last_modified"
 * }
 * Returns 202:
 * {
 * "request_id": 123,
 * "status": "pending",
 * "progress_percentage": 0,
 * "item_count": 0
 * }
 * @summary Start an async deals pipeline report export
 * {@link /api/v1/reports/dashboard/deals-pipeline/export/v2/}
 */
export async function exportDealsPipelineReportV2(
  data: ExportDealsPipelineReportV2MutationRequest,
  config: Partial<RequestConfig<ExportDealsPipelineReportV2MutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ExportDealsPipelineReportV2MutationResponse,
    ResponseErrorConfig<
      ExportDealsPipelineReportV2400 | ExportDealsPipelineReportV2500
    >,
    ExportDealsPipelineReportV2MutationRequest
  >({
    method: 'POST',
    url: getExportDealsPipelineReportV2Url().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
